import React from 'react';
import QuoteRequestDetailSection from '../../../sections/AdminDashboard/Quotes/QuoteRequestDetail';

const QuoteRequestDetail = () => {
  return <QuoteRequestDetailSection />;
};

export default QuoteRequestDetail;
